import { createLogic } from "redux-logic";
import { getMyGroup } from "../../../data/api";
import { handleErrors } from "../../../data/helpers";
import { setGroup } from "../actions";
import { PostAttendeeActionsActionTypes } from "../types";
var getGroupsLogic = createLogic({
    type: PostAttendeeActionsActionTypes.GET_GROUP,
    latest: true,
    process: function (_a, dispatch, done) {
        var action = _a.action;
        var localAction = action;
        getMyGroup(localAction.payload.lookupId, localAction.payload.eventNumber)
            .then(function (_a) {
            var data = _a.data;
            dispatch(setGroup(data));
        })
            .catch(function (err) {
            handleErrors(err, dispatch);
        })
            .finally(function () {
            done();
        });
    },
});
var exportable = [getGroupsLogic];
export default exportable;
